import { getRequest, postRequest, putRequest, deleteRequest } from "./request";

// 官网首页
export const getIndex = (page) => getRequest("index", { page });
// 获取主营产业详情
export const getZhuying = (id) => getRequest("zhuying/" + id);
// 新闻列表
export const getNews = (page, category_id) =>
  getRequest("news", { page, category_id });
// 新闻详情
export const getDetail = (id) => getRequest("detail/" + id);
// 党建新闻列表
export const getParty = (page, category_id) =>
  getRequest("party", { page, category_id });
// 党建新闻详情
export const getPartyDetail = (id) => getRequest("party/" + id);
// 项目列表
export const getProject = (page) => getRequest("project", { page });
// 项目详情
export const getProjectdetail = (id) => getRequest("project/" + id);
// 岗位列表
export const getJoin = (page) => getRequest("join", { page });
// 岗位详情
export const getJoindetail = (id) => getRequest("joindetail/" + id);
// 投递简历
export const addJoinsubmit = (params) => postRequest("joinsubmit", params);
// 关于我们
export const getAbout = () => getRequest("about");
// 获取系统字段信息
export const getSystem = (id) => getRequest("system/" + id);

// 登录接口，获取tokenStr
export const getLogin2 = (params) => putRequest("login", { params });
export const getLogin3 = (params) => deleteRequest("login", { params });
